export enum AddActivityMode {
  UNKNOWN = 0,
  UNKNOWN_REST = 1,
  EACH_ACTIVITY = 2,
}
